import * as React from 'react'
import { ButtonSeeker, IconSeekers } from "ui-seeker/core"
import { ModalOccupancy } from "app/components"

export default function SelectOccupancy(props) {

    const { setOpen, adults, kids } = props

    const handleClick = () => {
        setOpen(true)
    }

    return <div className="content-all">
        <ButtonSeeker size="small" variant="outlined" onClick={handleClick}>
            <IconSeekers icon="user" iconType="fontAwesome" />
            <span className="mx-8">Occupancy: {adults}-{kids}</span>
            <IconSeekers icon="angle-down" iconType="fontAwesome" style={{fontSize: '20px', color: '#CCC'}} />
        </ButtonSeeker>
        <ModalOccupancy {...props} />
    </div>
}